import { render, staticRenderFns } from "./DetalleExpediente.vue?vue&type=template&id=36200726&"
import script from "./DetalleExpediente.vue?vue&type=script&lang=js&"
export * from "./DetalleExpediente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports